export default __webpack_public_path__ + "static/media/last5.e77a0537.jpg";